<template>
  <el-form ref="form" :model="curInput.default" :rules="rules" label-width="100px">
    <el-form-item label="字段名" prop="name" v-if="showName">
      <el-input v-model.trim="curInput.default.name" class="h-40 w-200" :maxlength="64"></el-input>
      <div class="form-tips">字段名格式：英文或数字，可带下划线，必须以英文开头</div>
    </el-form-item>
    <el-form-item label="字段标题" prop="title">
      <el-input v-model.trim="curInput.default.title" class="h-40 w-200"></el-input>
    </el-form-item>
    <el-form-item label="提示信息" prop="tips">
      <el-input v-model.trim="curInput.default.tips" class="h-40 w-200"></el-input>
    </el-form-item>
    <el-form-item label="是否必填" prop="is_needed">
      <el-radio-group v-model="curInput.default.is_needed">
        <el-radio :label="1" :disabled="notNeed">是</el-radio>
        <el-radio :label="0" :disabled="notNeed">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <!-- <el-form-item label="是否列表展示" prop="is_show">
      <el-radio-group v-model="curInput.default.is_show">
        <el-radio :label="1" :disabled="curInput.type == TYPE_FILE || curInput.type == TYPE_EDITOR">是</el-radio>
        <el-radio :label="0" :disabled="curInput.type == TYPE_FILE || curInput.type == TYPE_EDITOR">否</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否可筛选字段" prop="is_filter">
      <el-radio-group v-model="curInput.default.is_filter">
        <el-radio :label="1" :disabled="curInput.type == TYPE_FILE || curInput.type == TYPE_EDITOR">是</el-radio>
        <el-radio :label="0" :disabled="curInput.type == TYPE_FILE || curInput.type == TYPE_EDITOR">否</el-radio>
      </el-radio-group>
    </el-form-item> -->
  </el-form>
</template>

<script>
  import modelConfig from '../../../config/modelConfig'
  export default {
    props: {
      curInput: {
        type: Object,
        default() {
          return {
            default: {}
          }
        }
      },
      inputList: {
        type: Array,
        default() {
          return []
        }
      },
      showName: {
        type: Boolean,
        default() {
          return true
        }
      }
    },
    data() {
      return {
        rules: {
          name: [
            { required: true, message: '请输入字段名' },
            { validator: this.checkFieldName, trigger: 'blur' },
            { validator: this.checkDulpicate, trigger: 'blur' }
          ],
          title: [
            { required: true, message: '请输入字段标题' }
          ]
        },
        illegal: /[\b\t\s\n]/g // 转义符黑名单
      }
    },
    mixins: [modelConfig],
    created() {
    },
    methods: {
      isFieldName(value) {
        return (/^[A-za-z][A-za-z0-9]+$/g).test(value)
      },
      isDulpicate(value) {
        let eqCount = 0
        _(this.inputList).forEach((res) => {
          if (!res.default.is_deleted && res.default.name == value) {
            eqCount++
          }
        })
        _(this.inputList).forEach((res) => {
          let count = 0
          _(this.inputList).forEach((secRes) => {
            if (!res.default.is_deleted && !secRes.default.is_deleted && res.default.name === secRes.default.name) {
              count++
            }
          })
          if (count > 1) {
            res.isDulpicate = true
            return
          }
          res.isDulpicate = false
        })
        return eqCount > 1
      },
      checkFieldName(rule, value, callback) {
        if (!this.isFieldName(value)) {
          callback(new Error('请输入正确的字段名格式'))
        } else {
          callback()
        }
      },
      checkDulpicate(rule, value, callback) {
        if (this.isDulpicate(value)) {
          callback(new Error('存在重复字段名'))
        } else {
          callback()
        }
      }
    },
    watch: {
      'curInput.default.name'() {
        this.curInput.default.name = this.curInput.default.name.replace(this.illegal, '')
      },
      'curInput'() {
        if (this.isDulpicate(this.curInput.default.name)) {
          _g.toastMsg(this, 'error', '当前字段名存在重复')
        }
      },
      'curInput.default.type'() {
        if (this.curInput.default.type == this.TYPE_DEALTIME) {
          this.curInput.default.is_needed = 0
        }
      }
    },
    computed: {
      notNeed() {
        return this.curInput.default.type == this.TYPE_DEALTIME
      }
    }
  }
</script>


// WEBPACK FOOTER //
// commonConfig.vue?74a98140